import { observer } from 'mobx-react';
import React from 'react';
import { promobannerStore } from '../../store/promobannerStore';
import { localeStore } from 'src/mobx/localesStore';
import Input from '~/view/components/Controls/InputComponent/Input';
import Text from '~/view/components/Text/Text';
import './style.scss';

@observer
export default class PromobannerName extends React.Component<{}, {}> {
  onChangeName = (value: string | undefined) => {
    promobannerStore.changePromobanner({ name: value }, true);
  };

  render() {
    return (
      <div className="promobanner-name__container mt-6">
        <Text type="block-header" text="hint_name" required />
        <Input
          value={promobannerStore.promobanner.name}
          onChangeValue={this.onChangeName}
          validation={{ isValid: promobannerStore.isValid.name }}
          placeholder={localeStore.t('type_name')}
          contentClassName="promobanner-name__input mt-2"
        />
      </div>
    );
  }
}
